// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","tabWrapper":"styles_tabWrapper__2dqxr","tabInactive":"styles_tabInactive__3MUd2","count":"styles_count__20iNW"};